import { Checkbox } from '.';
import Input from './input';
import InputSelect from './InputSelect';

export default function InputGroup({
  label,
  fields,
  labelClassName,
  className,
  fieldsClassName,
  disabled
}) {
  return (
    <div className={`my-2 ${className}`}>
      {label && <label className={`text-lg ${labelClassName}`}>{label}</label>}
      <div className={fieldsClassName}>
        {fields.map((field, index) => {
          if (field.type === 'select') {
            return <InputSelect key={index} className="my-2" disabled={disabled} {...field} />;
          }

          if (field.type === 'checkbox') {
            return <Checkbox key={index} className="my-2" disabled={disabled} {...field} />;
          }

          return <Input key={index} className="my-2" disabled={disabled} {...field} />;
        })}
      </div>
      {/* <div className="">
        <p className="text-xs">Max. 90 characters</p>
      </div> */}
    </div>
  );
}
